import React from "react";
import Button from "./Button";
import Container from "./Container";
import Searchbar from "./Searchbar";
import Table1 from "./Table1";
import { useReducer,useState,useEffect } from "react";
import { reducer,initialState } from "../reducers/reducers";
import Dropdown from "./Dropdown";
import NewClient from "./NewClient";
import NewItem from "./NewItem";
import API_URLS from "../Urls";
import EditItem from "./EditItem";
import Confirm from "./Confirm";
import { useAuth } from "./AuthProvider";

// Componente para el catálogo de productos
const Catalogue = () => {
    const [selectedOption, setSelectedOption] = useState('Servicios');
    const [data,setData] =useState([])
    const [viewItem,setViewItem] = useState()
    const [state, dispatch] = useReducer(reducer, initialState);
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    // Estados para paginación
    const [page, setPage] = useState(1);
    const [perPage] = useState(20); // Fijo a 20
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [isSearching, setIsSearching] = useState(false);
    
    // Obtener permisos del usuario
    const { canRead, canWrite } = useAuth();
    const canReadCatalogo = canRead('acceso_catalogo');
    const canWriteCatalogo = canWrite('acceso_catalogo');

    const handleDropdownChange = (option) => {
        setSelectedOption(option);
        setPage(1); // Reiniciar a la primera página al cambiar tipo
    };

    const singularize = (option) => {
  if (["Accesorios", "Partes", "Servicios"].includes(option)) {
    return option.slice(0, -1); // remove the trailing 's'
  }
  return option;
};    
    const fetchData =(url)=>{ // Función para obtener los datos del catálogo
        // Verificar si el usuario tiene permisos de lectura
        if (!canReadCatalogo) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            setData([]); setFilteredData([]); setLastPage(1); setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }
        
        // Agregar parámetros de paginación
        const paginatedUrl = `${url}?page=${page}&per_page=${perPage}`;
        console.log(`Solicitando datos: ${paginatedUrl}`);
        
        fetch(paginatedUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(result => {
            // Si la respuesta es paginada
            if (result && result.data && result.page !== undefined) {
                console.log(`Respuesta paginada: ${result.data.length} elementos, página ${result.page} de ${result.last_page}, total: ${result.total}`);
                setData(result.data);
                setFilteredData(result.data); // Inicializar filteredData con los mismos datos
                setLastPage(result.last_page);
                setTotal(result.total);
            } else {
                // Respaldo para respuesta no paginada
                const dataArray = Array.isArray(result) ? result : [];
                console.log(`Respuesta no paginada: ${dataArray.length} elementos`);
                setData(dataArray);
                setFilteredData(dataArray); // Inicializar filteredData con los mismos datos
                
                // Aplicar paginación local
                const calculatedLastPage = Math.ceil(dataArray.length / perPage) || 1;
                console.log(`Calculando paginación local: ${calculatedLastPage} páginas`);
                
                setLastPage(calculatedLastPage);
                setTotal(dataArray.length);
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            setData([]);
            setFilteredData([]);
            setLastPage(1);
            setTotal(0);
        });
    }
    const deleteData =(url,onSuccesful)=>{ // Función para obtener los datos del catálogo
        // Verificar si el usuario tiene permisos de lectura
        if (!canWriteCatalogo) {
            console.error('No tienes permisos para eliminar');
            alert('No tienes permisos para eliminar');
            return Promise.reject('No tienes permisos para eliminar');
        }

        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => { // Verifica si la respuesta es ok
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(data => {if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data); })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    }

    // Función para obtener los datos del catálogo
    const requestData = () => {
        switch(selectedOption){
            case 'Servicios':
                fetchData(API_URLS.SERVICES);
                break;
            case 'Dron Enterprise':
            case 'Dron Comercial':
                fetchData(API_URLS.DRONES);
                break;
            case 'Accesorios':
                fetchData(API_URLS.ACCESORIES);
                break;
            case 'Partes':
                fetchData(API_URLS.PARTS);
                break;
            default:
                fetchData(API_URLS.SERVICES);
        }
    }

    useEffect(() => {
        setIsSearching(false); // Resetear búsqueda al cambiar de opción
        setSearchText(""); // Limpiar texto de búsqueda
        requestData();
    }, [selectedOption, page]); // Ejecutar cuando cambia la opción o la página

    // Función para manejar la búsqueda
    const handleSearch = () => {
        if (!searchText.trim()) {
            // Si el texto de búsqueda está vacío, no hacemos nada
            return;
        }

        // Verificar si el usuario tiene permisos de lectura
        if (!canReadCatalogo) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            setFilteredData([]); setLastPage(1); setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }
        
        setIsSearching(true);
        setPage(1); // Reiniciar a la primera página
        
        let filtered;
        
        switch(selectedOption) {
            case 'Servicios':
                filtered = data.filter(item =>
                    (item.nombre && item.nombre.toLowerCase().includes(searchText.toLowerCase())) ||
                    (item.linea && item.linea.toLowerCase().includes(searchText.toLowerCase()))
                );
                break;
            case 'Dron Enterprise':
            case 'Dron Comercial':
                filtered = data.filter(item =>
                    (item.linea && item.linea.toLowerCase().includes(searchText.toLowerCase())) ||
                    (item.serie && item.serie.toLowerCase().includes(searchText.toLowerCase())) ||
                    (item.modelo && item.modelo.toLowerCase().includes(searchText.toLowerCase()))
                );
                break;
            case 'Accesorios':
                filtered = data.filter(item =>
                    (item.tipo && item.tipo.toLowerCase().includes(searchText.toLowerCase())) ||
                    (item.modelo && item.modelo.toLowerCase().includes(searchText.toLowerCase()))
                );
                break;
            case 'Partes':
                filtered = data.filter(item =>
                    (item.nombre && item.nombre.toLowerCase().includes(searchText.toLowerCase())) ||
                    (item.dron && item.dron.toLowerCase().includes(searchText.toLowerCase())) ||
                    (item.no_serie && item.no_serie.toLowerCase().includes(searchText.toLowerCase()))
                );
                break;
            default:
                filtered = data;
        }
        
        console.log(`Búsqueda: ${searchText} - ${filtered.length} resultados encontrados`);
        
        // Aplicar paginación local a los resultados de búsqueda
        const calculatedLastPage = Math.ceil(filtered.length / perPage) || 1;
        
        // Obtener solo los datos de la página actual
        const startIndex = (page - 1) * perPage;
        const endIndex = Math.min(startIndex + perPage, filtered.length);
        const paginatedData = filtered.slice(startIndex, endIndex);
        
        setFilteredData(filtered);
        setLastPage(calculatedLastPage);
        setTotal(filtered.length);
    };
    
    // Función para limpiar la búsqueda
    const clearSearch = () => {
        setSearchText("");
        setIsSearching(false);
        setPage(1); // Reiniciar a la primera página
        setFilteredData(data); // Restaurar datos originales
        
        // Recalcular paginación para datos completos
        const calculatedLastPage = Math.ceil(data.length / perPage) || 1;
        setLastPage(calculatedLastPage);
        setTotal(data.length);
    };

    // Controles de paginación
    function PaginationControls() {
        // Siempre mostrar controles, tanto para datos normales como para resultados de búsqueda
        
        // Estilos para los botones
        const buttonStyle = {
            backgroundColor: '#7AACE3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            margin: '0 5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
        };

        const disabledButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#cccccc',
            cursor: 'not-allowed',
            opacity: 0.7
        };
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0' }}>
                <button 
                    onClick={() => setPage(prev => Math.max(prev - 1, 1))} 
                    disabled={page === 1}
                    style={page === 1 ? disabledButtonStyle : buttonStyle}
                >
                    &lt; Anterior
                </button>
                <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
                    Página {page} de {lastPage} ({total} registros)
                    {isSearching && ' - Resultados de búsqueda'}
                </span>
                <button 
                    onClick={() => setPage(prev => Math.min(prev + 1, lastPage))} 
                    disabled={page === lastPage}
                    style={page === lastPage ? disabledButtonStyle : buttonStyle}
                >
                    Siguiente &gt;
                </button>
            </div>
        );
    }

    function renderTable(data){
        // Aplicar paginación local a los datos si no estamos en modo búsqueda
        let displayData = data;
        
        if (!isSearching) {
            // Aplicar paginación local a los datos
            const startIndex = (page - 1) * perPage;
            const endIndex = Math.min(startIndex + perPage, data.length);
            displayData = data.slice(startIndex, endIndex);
        }
        
        if(selectedOption==='Servicios'){
            return(
            <div>
            <Table1 headers={['id','nombre','linea','precio',]} onClickEdit={(data)=>{setViewItem({id:data.id,type:'Servicios'});dispatch({type:'openEditItem'})}} optedit={canWriteCatalogo} onClickDelete={(data)=>{dispatch({type:'openConfirmMessage'});setViewItem({id:data.id,url:API_URLS.SERVICES})}} optdelete={canWriteCatalogo} data={displayData}></Table1>     
            </div>
            )
        }
        if(selectedOption==='Dron Enterprise'){
            return(
            <div>
            <Table1 headers={['id','linea','serie','modelo','precio',]} onClickEdit={(data)=>{setViewItem({id:data.id,type:'Dron Enterprise'});dispatch({type:'openEditItem'})}} optedit={canWriteCatalogo} optdelete={canWriteCatalogo} onClickDelete={(data)=>{console.log(data);dispatch({type:'openConfirmMessage'});setViewItem({id:data.id,url:API_URLS.DRONES})}} data={displayData.filter(item=>item['linea']==='Enterprise')}></Table1>     
            </div>
            )
        }
        
        if(selectedOption==='Dron Comercial'){
            return(
            <div>
            <Table1 headers={['id','linea','serie','modelo','precio',]} onClickEdit={(data)=>{console.log(data.id);setViewItem({id:data.id,type:'Dron Comercial'});dispatch({type:'openEditItem'})}} optedit={canWriteCatalogo} onClickDelete={(data)=>{dispatch({type:'openConfirmMessage'});setViewItem({id:data.id,url:API_URLS.DRONES})}} optdelete={canWriteCatalogo} data={displayData.filter(item=>item['linea']==='Comercial')}></Table1>
            </div>
            )
        }
        if(selectedOption==='Partes'){
            return(
            <div>

            <Table1 headers={['id','tipo','modelo','precio']} onClickEdit={(data)=>{setViewItem({id:data.id,type:'Partes'});dispatch({type:'openEditItem'})}} optedit={canWriteCatalogo} onClickDelete={(data)=>{dispatch({type:'openConfirmMessage'});setViewItem({id:data.id,url:API_URLS.PARTS})}} optdelete={canWriteCatalogo} data={displayData}></Table1>

            </div>
            )
        }
        if(selectedOption==='Accesorios'){
            return(
            <div>
            <Table1 headers={['id','tipo','modelo','precio']} onClickEdit={(data)=>{setViewItem({id:data.id,type:'Accesorios'});dispatch({type:'openEditItem'})}} onClickDelete={(data)=>{dispatch({type:'openConfirmMessage'});setViewItem({id:data.id,url:API_URLS.ACCESORIES})}} optedit={canWriteCatalogo} optdelete={canWriteCatalogo} data={displayData}></Table1>
            </div>
            )
        }
    }

    return( // Renderiza el componente
        <div className="anylayout">
            <div className="titleFont">Catalogo</div>
            <Container>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                    <div>Tipo:</div>
                    <Dropdown returnSelectedOption={handleDropdownChange} options={['Servicios','Dron Enterprise','Dron Comercial', 'Accesorios','Partes']}></Dropdown>
                    <Searchbar 
                        text="Buscar..." 
                        value={searchText} 
                        onChange={setSearchText} 
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSearch();
                            }
                        }}
                    />
                    <Button text="🔎" color="#7AACE3" onClick={handleSearch} />
                    {isSearching && (
                        <Button text="Limpiar búsqueda" onClick={clearSearch} color="#DF7476" />
                    )}
                </div>
                {canWriteCatalogo && (
                    <Button text="➕" onClick={()=>{dispatch({type:'openNewItem'})}}color="#7AACE3"></Button>
                )}
            </Container>
            {isSearching && (
                <div style={{ textAlign: 'center', margin: '10px 0', fontStyle: 'italic' }}>
                    Mostrando resultados de búsqueda para: "{searchText}" ({total} resultados)
                </div>
            )}
            <PaginationControls />
            {renderTable(filteredData)}
            <PaginationControls />
            {state.statusEditItem && (
                <EditItem onSave={()=>{requestData()}} item={viewItem.id} onClose={()=>{dispatch({type:'closeEditItem'})}} type={viewItem.type}></EditItem>
            )}
            {state.statusNewItem && (
                <NewItem selectedType={singularize(selectedOption)} onAccept={()=>{dispatch({type:'closeNewItem'});requestData()}} onClose={()=>{dispatch({type:'closeNewItem'})}}></NewItem>
            )}
            {state.statusConfirmMessage && (
                <Confirm onCancel={()=>dispatch({type:'closeConfirmMessage'})} onDelete={()=>{console.log(viewItem.id);deleteData(viewItem.url+"?id="+viewItem.id,()=>{dispatch({type:'closeConfirmMessage'});requestData()})}}></Confirm>
            )}
        </div>
    );
}
export default Catalogue;